import React from 'react';
import { motion } from 'framer-motion';
import { cardVariants } from '@/lib/motion-variants';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  spotlight?: boolean;
  onClick?: () => void;
}

const GlassCard: React.FC<GlassCardProps> = ({ 
  children, 
  className = '', 
  hover = true,
  spotlight = true,
  onClick 
}) => {
  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    if (!spotlight) return;
    const target = e.currentTarget;
    const { left, top } = target.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;
    target.style.setProperty('--mouse-x', `${x}px`);
    target.style.setProperty('--mouse-y', `${y}px`);
  };

  const classNames = `glass-panel spotlight-card ${className}`;

  if (onClick) {
    return (
      <motion.button
        type="button"
        onMouseMove={handleMouseMove}
        className={classNames}
        variants={hover ? cardVariants : undefined}
        whileHover={hover ? 'hover' : undefined}
        onClick={onClick}
      >
        {children}
      </motion.button>
    );
  }

  return (
    <motion.div
      onMouseMove={handleMouseMove}
      className={classNames}
      variants={hover ? cardVariants : undefined}
      whileHover={hover ? 'hover' : undefined}
    >
      {children}
    </motion.div>
  );
};

export default GlassCard;
